import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { ssoConfig } from "../../utils/sso/config";
import { decodeJwt } from "../../utils/sso/pkce";
import { setCookie } from "../../utils/common/cookies";
import { loginUserResponse } from "../../store/actions";

const buildUser = (accessToken, idToken) => {
  const claims = decodeJwt(accessToken) || {};
  const profile = decodeJwt(idToken) || {};
  const roles = Array.isArray(claims.roles) ? claims.roles : [];
  const lowered = roles.map((r) => String(r).toLowerCase());
  const role = lowered.includes("admin") ? "admin" : lowered[0] || "";
  return {
    id: claims.userId || claims.sub,
    userId: claims.userId,
    companyId: claims.companyId,
    email: profile.email || claims.email || claims.sub,
    username: profile.name || claims.sub,
    roles,
    role,
  };
};

const SsoCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const verifier = sessionStorage.getItem("sso_verifier");
      const expectedState = sessionStorage.getItem("sso_state");

      if (params.get("error")) {
        throw new Error(params.get("error_description") || params.get("error"));
      }
      if (!code || !verifier) throw new Error("Missing authorization code");
      if (expectedState && state !== expectedState) {
        throw new Error("State mismatch, please sign in again");
      }

      const { data } = await axios.post(
        ssoConfig.tokenUrl,
        {
          client_id: ssoConfig.clientId,
          code,
          code_verifier: verifier,
          redirect_uri: ssoConfig.redirectUri,
        },
        { baseURL: "" }
      );

      sessionStorage.removeItem("sso_verifier");
      sessionStorage.removeItem("sso_state");
      setCookie("token", data.access_token);
      if (data.id_token) setCookie("id_token", data.id_token);
      if (data.refresh_token) setCookie("refresh_token", data.refresh_token);
      dispatch(loginUserResponse(buildUser(data.access_token, data.id_token)));
      navigate("/", { replace: true });
    };

    run().catch((e) => {
      const message =
        e?.data?.error_description || e?.data?.error || e?.message || "Sign-in failed";
      setError(message);
      toast.error(message);
    });
  }, [dispatch, navigate]);

  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      {error ? (
        <>
          <p>{error}</p>
          <button type="button" onClick={() => navigate("/login")}>
            Back to login
          </button>
        </>
      ) : (
        <p>Signing you in...</p>
      )}
    </div>
  );
};

export default SsoCallback;
